import React, { useMemo, useState, useEffect, useCallback } from 'react'
import useAgent from 'Core/Hooks/useAgent'
import { enqueueNotification } from 'Utils/Helpers'
import { useAPIKeys } from 'features/settings'
import AppCard from './Components/AppCards'

export default function InstallAgent() {
  const { APP_LISTING, activeDeviceOS } = useAgent()
  const [activeOSByType, setActiveOSByType] = useState({})
  const { apiKeys } = useAPIKeys()
  const user = JSON.parse(localStorage.getItem('user'))
  const cards = useMemo(() => {
    return APP_LISTING.map((appDef) => {
      const variants = Object.entries(appDef.osName || {}).map(([osName, v]) => ({
        osName,
        Icon: v.Icon,
        osRequirement: v.osRequirement,
        link: v.link
      }))
      const showDownloadButton = appDef.showDownloadButton
      const defaultOS =
        variants.find((v) => v.osName === activeDeviceOS)?.osName || variants[0]?.osName
      return { type: appDef.type, name: appDef.name, variants, defaultOS, showDownloadButton }
    })
  }, [APP_LISTING, activeDeviceOS])

  let config = {
    Tenant: user.tenant,
    APIKey: apiKeys.ApiKey,
    APISecret: apiKeys.ApiSecret,
    CNTRLUrl: `https://${user.controller}`,
    SyncTimeMin: '10'
  }

  useEffect(() => {}, [apiKeys])

  useEffect(() => {
    setActiveOSByType((prev) => {
      const next = { ...prev }
      for (const c of cards) {
        if (!next[c.type]) next[c.type] = c.defaultOS
      }
      return next
    })
  }, [cards])

  const setActiveOS = (type, os) => setActiveOSByType((prev) => ({ ...prev, [type]: os }))

  const onCopy = (link, osLabel) => {
    if (!link) return
    navigator.clipboard
      .writeText(link)
      .then(() => {
        enqueueNotification(`${osLabel} download link copied`, 'info')
      })
      .catch((err) => {
        console.error('Clipboard error:', err)
      })
  }

  return (
    <div className=''>
      <div className='flex items-center flex-row gap-7 flex-wrap'>
        {cards.map((card) => {
          const activeOS = activeOSByType[card.type] || card.defaultOS
          const activeVariant = card.variants.find((v) => v.osName === activeOS) || card.variants[0]

          const app = {
            name: card.name,
            osName: activeVariant.osName,
            osRequirement: activeVariant.osRequirement,
            link: activeVariant.link
          }
          const appList = card.variants

          return (
            <AppCard
              type={card.type}
              key={card.type}
              app={app}
              appList={appList}
              activeOS={activeOS}
              setActiveOS={(os) => setActiveOS(card.type, os)}
              onCopy={() => onCopy(activeVariant.link, activeVariant.osName)}
              config={config}
              showDownloadButton={card.showDownloadButton}
            />
          )
        })}
      </div>
    </div>
  )
}
